import React from "react";
import CampusLifeFormPage from "../components/campus-life/CampusLifeFormPage";

const CampusLifeCreate = () => <CampusLifeFormPage mode="create" />;

export default CampusLifeCreate;
